<template>
    <div class="container-fluid">
        <Breadcrumb title="Pmta Email Test" button-url="pmtaEmailTestCreate"></Breadcrumb>
        <div class="row" style="position: relative">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="input-group form-group">
                            <div class="form-group" v-if="this.isAdmin">
                                <treeselect placeholder="Search by owner"
                                            v-model="userSearch"
                                            :multiple="false"
                                            :options="userList"
                                            :load-options="loadUserList"
                                />
                            </div>
                            <div class="form-group">
                                <treeselect placeholder="Search by Status"
                                            v-model="statusSearch"
                                            :multiple="false"
                                            :options="statusList"
                                            :load-options="loadEmailTestStatusesList"
                                />
                            </div>
                            <input v-model="pmtaRelaySearch" type="text" class="form-control form-control-line"
                                   placeholder="Search by relay hostname">
                            <div class="input-group-append">
                                <button v-on:click="search" class="btn btn-info" type="button">Search</button>
                            </div>
                        </div>
                        <div class="form-group mx-sm-3 mb-2">
                                <span>Total:
                                    <span class="label label-info">{{totalItems}}</span>
                                </span>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="col-12" v-if="loading" style="min-height:100px;">
                            <Preloader v-bind:class="{preloader: loading}"></Preloader>
                        </div>
                        <div v-else>
                            <div v-if="pmtaEmailTestList.length > 0">
                                <div>
                                    <div class="table-responsive">
                                        <table class="table">
                                            <thead>
                                            <tr>
                                                <th @click="tableOrdering('id')">
                                                    <span role='button'>Date</span>
                                                </th>
                                                <th @click="tableOrdering('email')">
                                                    <span role='button'>To</span>
                                                </th>
                                                <th @click="tableOrdering('pmtaRelay.smtpHost')">
                                                    <span role='button'>Pmta Relay</span>
                                                </th>
                                                <th>
                                                    <span>Message</span>
                                                </th>
                                                <th>
                                                    <span>Offer</span>
                                                </th>
                                                <th>
                                                    <span>Sender</span>
                                                </th>
                                                <th v-if="isAdmin">Owner</th>
                                                <th @click="tableOrdering('status')">
                                                    <span role='button'>Status</span>
                                                </th>
                                                <th>
                                                </th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="(pmtaEmailTest, index) in pmtaEmailTestList" :key="index">
                                                <td class="align-middle">{{moment.utc(pmtaEmailTest.date.toString()).format('YYYY-M-D H:mm')}}</td>
                                                <td class="align-middle">{{pmtaEmailTest.email}}</td>
                                                <td class="align-middle">{{pmtaEmailTest.pmtaRelay.smtpHost}}</td>
                                                <td class="align-middle">{{pmtaEmailTest.message.name}}</td>
                                                <td class="align-middle">{{pmtaEmailTest.offer.name}}</td>
                                                <td class="align-middle">{{pmtaEmailTest.sender}}</td>
                                                <td class="align-middle" v-if="isAdmin">{{pmtaEmailTest.user.username}}</td>
                                                <td class="align-middle">{{statusList[pmtaEmailTest.status].label}}</td>
                                                <td class="align-middle">
                                                    <router-link :to="{ name: 'pmtaEmailTestCreate', params: { cloneId: pmtaEmailTest.id }}"
                                                                 class="btn btn-info m-r-10">
                                                        <i v-tooltip.top="'Clone'" class="fa fa-clone"></i>
                                                    </router-link>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <paginate v-if="pageCount > 1"
                                              v-model="page"
                                              :page-count="pageCount"
                                              :page-range="3"
                                              :margin-pages="2"
                                              :click-handler="getItems"
                                              :prev-text="'Prev'"
                                              :next-text="'Next'"
                                              :container-class="'pagination justify-content-center'"
                                              :page-class="'page-item'"
                                              :page-link-class="'page-link'"
                                              :prev-class="'page-item'"
                                              :prev-link-class="'page-link'"
                                              :next-class="'page-item'"
                                              :next-link-class="'page-link'">
                                    </paginate>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import EmailTestService from '../services/EmailTestService';
    import UserService from '../services/UserService';
    import Preloader from '../components/Preloader';
    import Breadcrumb from '../components/Breadcrumb';
    import paginateMixin from '../mixins/paginate-mixin';
    import Treeselect from '@riophae/vue-treeselect';

    export default {
        name: 'PmtaEmailTests',
        components: {
            Preloader, Breadcrumb, Treeselect
        },
        mixins: [paginateMixin],
        data() {
            return {
                isAdmin: this.$store.getters.isAdmin,
                orderField: 'date',
                orderDirection: 'desc',
                pmtaEmailTestList: [],
                userSearch: null,
                userList: null,
                pmtaRelaySearch: null,
                statusSearch: null,
                statusList: null,
                loading: false,
                totalItems: 0,
                page: 1,
                perPage: paginateMixin.defaultPerPage,
            }
        },
        mounted() {
            this.getItems(this.page = 1);
        },
        methods: {
            getItems: function (pageNum) {
                this.loading = true;
                EmailTestService.getPmtaEmailTests(
                    pageNum,
                    this.perPage,
                    this.orderField,
                    this.orderDirection,
                    this.pmtaRelaySearch,
                    this.statusSearch,
                    this.userSearch
                ).then(response => {
                    this.pmtaEmailTestList = response.data['hydra:member'];
                    this.totalItems = response.data['hydra:totalItems'];
                    this.loading = false;
                });
            },
            search: function () {
                this.getItems(this.page = 1);
            },
            tableOrdering(field) {
                if (this.orderField === field) {
                    this.orderDirection = (this.orderDirection === 'asc') ? 'desc' : 'asc';
                } else {
                    this.orderField = field;
                    this.orderDirection = 'asc';
                }
                this.getItems(this.page = 1);
            },
            loadUserList({callback}) {
                UserService.getUserSelect().then(response => {
                    this.userList = response.data['hydra:member'].map(user => {
                        return {id: user.id, label: user.username}
                    });
                    callback();
                });
            },
            loadEmailTestStatusesList({callback}) {
                EmailTestService.getEmailTestStatuses().then(response => {
                    this.statusList = response.data.statuses.map((status, index) => {
                        return {id: index, label: status}
                    });
                    callback();
                });
            }
        },
        computed: {
            pageCount: function () {
                return Math.ceil(this.totalItems / this.perPage);
            }
        }
    }
</script>

<style scoped>

</style>